'use strict';

module.exports.Page = {
  label: 'Page liée',
  picker_label: 'Chercher une page à lier',
  autocomplete_url: 'AutocompletePage'
};
module.exports.Project = {
  label: 'Numéro dossier',
  picker_label: 'N° de dossier',
  autocomplete_url: 'AutocompleteProject'
};
